import { BENEFIT_ICONS } from "@/hooks/useBenefits";

export default function BenefitBadge({ benefit }) {
  const Icon = BENEFIT_ICONS[benefit.icon] || BENEFIT_ICONS.star;
  return (
    <span
      data-testid={`benefit-badge-${benefit.id}`}
      title={benefit.description || benefit.title}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium bg-[#D4AF37]/8 text-[#E5C378] border border-[#D4AF37]/25"
    >
      <Icon className="w-3.5 h-3.5" />
      {benefit.title}
    </span>
  );
}
